import { useMemo } from "react"
import PropTypes from "prop-types"
import { DATE } from "helpers/shapes"
import ContributorsDetailsTable from "components/contributors-details-table"
import { formatLongDate } from "helpers/formatters/dates"

function ConcentrationDetails({
  selectedDate,
  contributorsSummaryText,
  data,
  openSecurityProfile,
  sort,
  order,
}) {
  const table = useMemo(() => (
    <ContributorsDetailsTable {...{
      data,
      openSecurityProfile,
      sort,
      order,
    }}
    />
  ), [data, openSecurityProfile, sort, order])
  return (
    <div className="details">
      <h4 className="header"><span>As of {formatLongDate(selectedDate)}</span></h4>
      <div className="contributors-details-wrapper">
        <div className="options-count">
          {contributorsSummaryText}
        </div>
        {table}
      </div>
    </div>
  )
}

ConcentrationDetails.propTypes = {
  selectedDate: DATE,
  contributorsSummaryText: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.object,
  ]).isRequired,
  data: PropTypes.array.isRequired,
  openSecurityProfile: PropTypes.func.isRequired,
  sort: PropTypes.func.isRequired,
  order: PropTypes.object.isRequired,
}

export default ConcentrationDetails
